import {
  CheckNotes,
  InspectionCapacityCase,
  InspectionCapacityCaseDto,
  InspectionCase
} from '../../inspection-cases';

export class FoamCenterDto extends InspectionCase {
  foamCenterType?: InspectionCase;
  certificatesAndCatalogs?: InspectionCase;
  dosageUnitType?: InspectionCase;
  concentrateType?: InspectionCase;
  concentratedContainerCapacity?: InspectionCapacityCaseDto;
  foamCenterSchemeAccordingSpec?: InspectionCase;
}

export class FoamCenter extends FoamCenterDto {
  constructor(data: FoamCenterDto = { title: 'מרכז קצף' }) {
    super(data);
    this.foamCenterType = new InspectionCase({
      ...data.foamCenterType,
      title: 'תאר את סוג מרכז הקצף'
    });
    this.certificatesAndCatalogs = new InspectionCase({
      ...data.certificatesAndCatalogs,
      title: 'אישורים וקטלוגים'
    });
    this.dosageUnitType = new InspectionCase({
      ...data.dosageUnitType,
      title: 'ציין את סוג יחידת המינון'
    });
    this.concentrateType = new InspectionCase({
      ...data.concentrateType,
      title:
        'ציין את סוג התרכיז והתאמתו ליחידת המינון, יחידת הקצה והחומרים המאוחסנים'
    });
    this.concentratedContainerCapacity = new InspectionCapacityCase({
      ...data.concentratedContainerCapacity,
      title: 'נפח מיכל התרכיז שתוכנן (liter)'
      // notes:
      //   data.notes && data.concentratedContainerCapacity.notes.length > 0
      //     ? data.concentratedContainerCapacity.notes
      //     : [
      //         {
      //           addNotesToReport: true,
      //           notes: 'נפח מיכל התרכיז שתוכנן: 0L'
      //         }
      //       ]
    });
    this.foamCenterSchemeAccordingSpec = new InspectionCase({
      ...data.foamCenterSchemeAccordingSpec,
      title: 'סכמת מרכז הקצף מתאימה לדרישות יצרן יחידת המינון ודרישות התקן?'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.foamCenterType.isApplicable || this.foamCenterType.isPassed) &&
        (!this.certificatesAndCatalogs.isApplicable ||
          this.certificatesAndCatalogs.isPassed) &&
        (!this.dosageUnitType.isApplicable || this.dosageUnitType.isPassed) &&
        (!this.concentrateType.isApplicable || this.concentrateType.isPassed) &&
        (!this.concentratedContainerCapacity.isApplicable ||
          this.concentratedContainerCapacity.isPassed) &&
        (!this.foamCenterSchemeAccordingSpec.isApplicable ||
          this.foamCenterSchemeAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.foamCenterType.getNotes(),
      ...this.certificatesAndCatalogs.getNotes(),
      ...this.dosageUnitType.getNotes(),
      ...this.concentrateType.getNotes(),
      ...this.concentratedContainerCapacity.getNotes(),
      ...this.foamCenterSchemeAccordingSpec.getNotes()
    ];
  }
}
